import {
	OFFICE_SAVED,
	OFFICE_SAVING,
	OFFICE_SAVING_FAILED,
	OFFICE_SAVING_INITIALIZE
} from "../actions/types";
const initialState = {
	isSaving: false,
	isSaved: false,
	isFailed: false,
	office: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case OFFICE_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isFailed: false,
				office: {},
			};
		case OFFICE_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				office: action.payload,
			};
		case OFFICE_SAVING_INITIALIZE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				office: {},
			};

		case OFFICE_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: true,
				office: {},
			};

		default:
			return state;
	}
}
